import { Component, inject, output, signal } from "@angular/core";
import { takeUntilDestroyed, toSignal } from "@angular/core/rxjs-interop";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
  RouterModule,
} from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { filter } from "rxjs";

import { OrgFacade } from "state/org.facade";
import {
  DevOrgDropdownComponent,
  DevUserOnlyDirective,
} from "./components/dev-org-dropdown";

import { BreadcrumbsComponent } from "./components/breadcrumbs/breadcrumbs.component";
import { NavigatingIndicatorComponent } from "./components/navigating-indicator/navigating-indicator.component";
import { ProfileDropdownComponent } from "./components/profile-dropdown/profile-dropdown.component";
import { NavLinksService } from "./services/nav-links.service";

@Component({
  selector: "app-nav-header",
  templateUrl: "./nav-header.component.html",
  styleUrls: ["./nav-header.component.scss"],
  standalone: true,
  host: { class: "inseer-ds" },
  imports: [
    RouterModule,
    TranslateModule,
    MatButtonModule,
    MatIconModule,
    ProfileDropdownComponent,
    BreadcrumbsComponent,
    NavigatingIndicatorComponent,
    DevOrgDropdownComponent,
    DevUserOnlyDirective,
  ],
})
export class NavHeaderComponent {
  private readonly orgFacade = inject(OrgFacade);
  private readonly router = inject(Router);
  private readonly navLinks = inject(NavLinksService);

  readonly menuClicked = output<void>();

  protected readonly logoUrl = toSignal(this.orgFacade.logoUrl$, {
    initialValue: "assets/icons/Inseer-logo-white.png",
  });

  protected readonly links = this.navLinks.links;
  protected readonly showCreate = this.navLinks.showCreate;

  protected readonly url = signal(this.router.url);

  constructor() {
    this.router.events
      .pipe(
        filter(
          (event) =>
            event instanceof NavigationStart ||
            event instanceof NavigationEnd ||
            event instanceof NavigationCancel ||
            event instanceof NavigationError
        ),
        takeUntilDestroyed()
      )
      .subscribe((event) => {
        this.url.set(event instanceof NavigationStart ? event.url : this.router.url);
      });
  }
}
